import React from 'react'
import { Breadcrumbs } from '@lightspeed/design-system-react'
import { STEPS } from './types'

const BREADCRUMBS = ['Method', 'Customer', 'Fulfillment details']
const BREADCRUMBS_WITH_ADD = [
  'Method',
  'Customer',
  'Add',
  'Fulfillment details',
]

interface Props {
  step: STEPS
  isAddingCustomer?: boolean
}

const getActiveBreadcrumb = (step: STEPS, isAddingCustomer: boolean) => {
  const breadcrumbs = isAddingCustomer ? BREADCRUMBS_WITH_ADD : BREADCRUMBS

  if (step === STEPS.DETAILS && !isAddingCustomer) {
    return breadcrumbs[step - 2]
  }
  return breadcrumbs[step - 1]
}

export const StepBreadcrumbs: React.FC<Props> = ({
  step,
  isAddingCustomer = false,
}) => {
  return (
    <Breadcrumbs
      breadcrumbs={isAddingCustomer ? BREADCRUMBS_WITH_ADD : BREADCRUMBS}
      activeBreadcrumb={getActiveBreadcrumb(step, isAddingCustomer)}
    />
  )
}
